import { createAsyncThunk } from '@reduxjs/toolkit';
import apiCall from '../../utils/api';
import { ISubscriptionPlan, ISubscriptionCounts } from './types';

export const fetchSubscriptionPlans = createAsyncThunk(
  'subscription/fetchPlans',
  async ({ page, pageSize, status, search }: { page: number; pageSize: number; status?: string; search?: string }, { rejectWithValue }) => {
    try {
      let url = `/api/subscriptions/plans/?page=${page}&page_size=${pageSize}`;
      if (status && status !== 'All') {
        url += `&is_active=${status === 'Active'}`;
      }
      if (search) {
        url += `&search=${encodeURIComponent(search)}`;
      }
      const response = await apiCall<{ status: boolean; data: { results: ISubscriptionPlan[]; count: number } }>('get', url);
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch subscription plans');
    }
  }
);

export const fetchSubscriptionCounts = createAsyncThunk(
  'subscription/fetchCounts',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiCall<{ status: boolean; data: ISubscriptionCounts }>('get', '/api/subscriptions/counts/');
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch subscription counts');
    }
  }
);
export const createSubscriptionPlan = createAsyncThunk(
  'subscription/createPlan',
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await apiCall<{ message: string }>('post', '/api/subscriptions/plans/', payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to create subscription plan');
    }
  }
);
export const fetchSubscriptionPlanDetail = createAsyncThunk(
  'subscription/fetchPlanDetail',
  async (id: string | number, { rejectWithValue }) => {
    try {
      const response = await apiCall<{ status: boolean; data: ISubscriptionPlan }>('get', `/api/subscriptions/plans/${id}/`);
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch subscription plan details');
    }
  }
);

export const fetchSubscribedOrganizations = createAsyncThunk(
  'subscription/fetchSubscribedOrganizations',
  async ({ planId, page, pageSize }: { planId: string | number; page: number; pageSize: number }, { rejectWithValue }) => {
    try {
      const response = await apiCall<{ status: boolean; data: { results: any[]; count: number } }>(
        'get', 
        `/api/subscriptions/plans/${planId}/organizations/?page=${page}&page_size=${pageSize}`
      );
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch subscribed organizations');
    }
  }
);

export const updateSubscriptionPlan = createAsyncThunk(
  'subscription/updatePlan',
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await apiCall<{ message: string }>('patch', '/api/subscriptions/plans/', payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to update subscription plan');
    }
  }
);

export const toggleSubscriptionPlanStatus = createAsyncThunk(
  'subscription/togglePlanStatus',
  async ({ planId, isActive }: { planId: number | string; isActive: boolean }, { rejectWithValue }) => {
    try {
      const response = await apiCall<{ message: string }>('patch', '/api/subscriptions/plans/', {
        plan_id: planId,
        is_active: isActive,
      });
      return { planId, isActive, message: response.data.message };
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to update plan status');
    }
  }
);
